import React from 'react'
import { Link } from 'react-router-dom'

const PageNotFound = (props) => {
    const { errorMessage = 'Disclosure Not Found' } = props

    return (
        <div id="wrapper">
            <div className="loadingSpinner">{errorMessage}</div>
            <div className="centered">
                <div className="flex nav-link">
                    <Link to="/">Return to Search</Link>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound
